import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_USER_CUSTOMER } from "../user-customer.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateUserCustomerInput } from "../../../__generated__/globalTypes";
import {
  CreateUserCustomerMutation,
  CreateUserCustomerMutationVariables,
} from "../../../__generated__/CreateUserCustomerMutation";

interface IProps {
  defaultValues: DeepPartial<CreateUserCustomerInput>;
  onCompleted: () => any;
}

export const useCreateUserCustomer = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateUserCustomerInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateUserCustomerMutation,
    CreateUserCustomerMutationVariables
  >(CREATE_USER_CUSTOMER, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createUserCustomer?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createUserCustomer?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
